
import {createSelector} from 'reselect';
import { CHANNEL_TYPE_AIRCALL, CHANNEL_TYPE_CHAT, CHANNEL_TYPE_EMAIL, CHANNEL_TYPE_WHATSAPP } from '../../sharedmailbox/common/constants';

export const currentSharedMailBoxIdSelector = (store) => store.sharedMailbox.currentSharedMailbox;
export const storeAllSharedMailboxSelector = (store) => store.sharedMailbox.allSharedMailboxes;
export const customerPortalSelector = (store) =>  store.sharedMailbox.customerPortal;
export const slaSmListSelector = (store) => store.sharedMailbox?.slaV2?.data || {};
export const smFeedbackPopupSelector = (store) => store.sharedMailbox.smFeedbackPopup;
export const currentSharedMailBoxSelector = createSelector(
    storeAllSharedMailboxSelector, 
    currentSharedMailBoxIdSelector, 
    (mailbox, mailId) => {
       return mailbox[mailId];
})

export const emailTypeInboxesSelector = createSelector(
    storeAllSharedMailboxSelector,
    (allSharedMailboxes) => { 
        const emailTypeInboxes = Object.values(allSharedMailboxes).filter(
            (inbox) => inbox.channel ? inbox.channel === CHANNEL_TYPE_EMAIL : true // payload doesn't contain inbox.channel when email type inboxes are fetched 
        );
        return emailTypeInboxes;
    }
)

export const activeSharedMailboxesSelector = createSelector(
    emailTypeInboxesSelector,
    (emailInboxes) => {
      const activeSharedMailboxes = emailInboxes.filter(
        (sm) =>  sm.active === 1 
      );
      return activeSharedMailboxes;
    }
)

export const chatInboxesSelector = createSelector(
    storeAllSharedMailboxSelector,
    (allSharedMailboxes) => (
        Object.values(allSharedMailboxes).filter(
            inbox => inbox.channel === CHANNEL_TYPE_CHAT)
    )
);

export const voiceInboxesSelector = createSelector(
    storeAllSharedMailboxSelector,
    (allSharedMailboxes) => (
        Object.values(allSharedMailboxes).filter(
            inbox => inbox.active === 1 && inbox.channel === CHANNEL_TYPE_AIRCALL)
    )
);

export const whatsappInboxesSelector = createSelector(
    storeAllSharedMailboxSelector,
    (allSharedMailboxes) => (
        Object.values(allSharedMailboxes).filter(
            inbox => inbox.channel === CHANNEL_TYPE_WHATSAPP)
    )
);

export const currentSharedmailBoxUsersSelector = createSelector(
    currentSharedMailBoxSelector, 
    (sm) => sm.smUsersList 
)

export const currentSharedmailBoxSourceEmailSelector = createSelector(
    currentSharedMailBoxSelector, 
    (sm) => sm.source_email 
)

export const currentSharedmailBoxSettings = createSelector(
    currentSharedMailBoxSelector, 
    (sm) => sm.sm_adv_settings 
)

export const currentSharedmailBoxTagsSelector = createSelector(
    currentSharedMailBoxSelector, 
    (sm) => sm.tags 
)

export const currentSharedmailBoxBusinessHourSelector = createSelector(
    currentSharedMailBoxSelector, 
    (sm) => sm.businesshour 
)

export const currentSharedmailBoxProperties = createSelector(
    currentSharedMailBoxSelector, 
    (sm) => sm.smProperties 
)
